import { ProjectRenderer } from '../ProjectRenderer';

export class Keyboard {
	constructor(private renderer: ProjectRenderer) {
		this.renderer = renderer;
		this.onKeyDown = this.onKeyDown.bind(this);
	}

	init() {
		window.addEventListener('keydown', this.onKeyDown);
	}

	private onKeyDown(event: KeyboardEvent) {
		switch (event.key) {
			default:
				break;
		}
	}
}
